(function () {
  class CashLinkIntro extends PIXI.Container {
    constructor() {
      super();

      this.visible = false;

      this.callback = undefined;
      this.continueUp = undefined;
      this.continueDown = undefined;
      this.baseName = "";
    }

    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this.baseName = "featurePopupContainer:cashLinkIntroPopup";
      this.coin = resourceManager.get(`${this.baseName}:coin`);

      this.congratulationsText = resourceManager.get(
        `${this.baseName}:coin:congratulationsText`
      );
      this.congratulationsImg = resourceManager.get(
        `${this.baseName}:coin:congratulationsTextImg`
      );
      this.youHaveWonText = resourceManager.get(
        `${this.baseName}:coin:youHaveWonText`
      );
      this.youHaveWonImg = resourceManager.get(
        `${this.baseName}:coin:youHaveWonImg`
      );
      this.cashLinkTextImg = resourceManager.get(
        `${this.baseName}:coin:cashLinkTextImg`
      );
      this.bonusTextImg = resourceManager.get(
        `${this.baseName}:coin:bonusTextImg`
      );
      this.continueButton = resourceManager.get(
        `${this.baseName}:coin:continueButton`
      );
      this.continueUp = resourceManager.get(
        `${this.baseName}:coin:continueButton:continueUp`
      );
      this.continueDown = resourceManager.get(
        `${this.baseName}:coin:continueButton:continueDown`
      );

      this.popupMaskDimObject = resourceManager.get(
        "featurePopupContainer:darkBackground"
      );
      this.popupMaskDimObject.visible = false;

      this.continueUp.interactive = false;
    }

    setup() {
      resourceManager.get(this.baseName).visible = true;

      this.continueUp.interactive = true;
      this.continueUp.mousedown = this.continueUp.touchstart =
        this.closeDialog.bind(this);
    }

    showIntro(callback) {
      let congratsObject;
      let youHaveWonObject;
      let lang;

      this.setup();

      this.callback = callback;

      //TODO: HB: Timeline this
      gsap.fromTo(
        [this.popupMaskDimObject, this],
        {
          alpha: 0,
        },
        {
          delay: 0.5,
          alpha: 1,
          duration: 0.5,
          onStart: () => {
            this.popupMaskDimObject.visible = true;
          },
          onComplete: () => {},
        }
      );

      gsap.fromTo(
        this.coin,
        {
          y: this.coin.y + 700,
        },
        {
          delay: 0.5,
          y: this.coin.y,
          duration: 0.3,
          onStart: () => {},
          onComplete: () => {},
        }
      );

      lang = gdk.getConfigValue("lang");

      if (lang === "en") {
        congratsObject = this.congratulationsImg;
        this.congratulationsText.visible = false;

        youHaveWonObject = this.youHaveWonImg;
        this.youHaveWonText.visible = false;
      } else {
        congratsObject = this.congratulationsText;
        this.congratulationsImg.visible = false;

        youHaveWonObject = this.youHaveWonText;
        this.youHaveWonImg.visible = false;
      }

      gsap.fromTo(
        congratsObject,
        {
          alpha: 0,
          y: congratsObject.y - 100,
        },
        {
          delay: 1,
          alpha: 1,
          y: congratsObject.y,
          duration: 0.3,
          onStart: () => {},
          onComplete: () => {},
        }
      );

      gsap.fromTo(
        [this.cashLinkTextImg, this.bonusTextImg, this.youHaveWonText],
        {
          alpha: 0,
        },
        {
          delay: 1.3,
          alpha: 1,
          duration: 0.3,
          onStart: () => {},
          onComplete: () => {},
        }
      );

      gsap.fromTo(
        this.continueButton,
        {
          alpha: 0,
        },
        {
          delay: 1.6,
          alpha: 1,
          duration: 0.3,
          onStart: () => {},
          onComplete: () => {},
        }
      );
    }

    closeDialog() {
      let self = this;
      this.popupMaskDimObject.visible = false;
      this.continueUp.interactive = false;
      this.continueUp.mousedown = this.continueUp.touchstart = undefined;

      this.continueUp.visible = false;
      this.continueDown.visible = true;
      gameController.messageBox.onSpinEnd(true);
      // Turn off click processing
      timerManager.addTimer(
        1000,
        function () {},
        function () {
          //TODO: HB: Animate the frame disappearing
          resourceManager.get(
            "featurePopupContainer:cashLinkIntroPopup"
          ).visible = false;
          self.continueUp.visible = true;
          self.continueDown.visible = false;
          resourceManager.get(self.baseName).visible = false;
          self.callback();
        }
      );

      gsap.fromTo(
        [this.popupMaskDimObject, this],
        {
          alpha: 1,
        },
        {
          alpha: 0,
          duration: 0.5,
          onStart: () => {},
          onComplete: () => {
            this.popupMaskDimObject.visible = false;
          },
        }
      );
    }
  }

  let cashLinkIntroCreator = function (json) {
    return new CashLinkIntro();
  };
  let cashLinkIntroInitialiser = function (json, disclaimer) {
    disclaimer.initialise();
  };
  let cashLinkIntroFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "CashLinkIntro",
    cashLinkIntroCreator,
    cashLinkIntroInitialiser,
    cashLinkIntroFilesRequired
  );
})();
